import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import {MatTableDataSource, MatPaginator } from '@angular/material';
import { RoleService } from 'src/app/shared/services/role.service';
import { AppSettings } from '../../../app.constant';
import { DataSource } from '@angular/cdk/table';

@Component({
  selector: 'app-role-table',
  templateUrl: './role-table.component.html',
  styleUrls: ['./role-table.component.css']
})
export class RoleTableComponent implements OnInit {

  displayedColumns: string[] =  ['PK_RoleID','RoleName','RoleDescription'];
  post:any;
  public resultdata:any;
  dataSource;
  errorMessage: String;
  progressBar:boolean = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private _roleservice:RoleService, changeDetectorRefs: ChangeDetectorRef) { }

  ngOnInit() {
    this._roleservice.refreshNeeded$
    .subscribe(()=>{
      this.getAllRole();
    })
    this.getAllRole();
    }

    getAllRole() {
      this._roleservice.getAllRole(AppSettings.API_ENDPOINT+AppSettings.GetAllRole)
      .subscribe(result =>{
        this.resultdata=result;
        this.progressBar = false;
        if(!result){
         return;
      }
  
      this.dataSource = new MatTableDataSource(this.resultdata);
      this.dataSource.paginator = this.paginator;
    });
    }


}

